const BASE = "/api/aichat";

async function jsonFetch(url, options = {}) {
  const res = await fetch(url, {
    credentials: "same-origin",
    headers: { "Content-Type": "application/json" },
    ...options,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data.message || data.error || `HTTP ${res.status}`);
    err.code = data.code;
    err.status = res.status;
    throw err;
  }
  return data;
}

export async function listRoles() {
  const data = await jsonFetch(`${BASE}/roles`);
  return data.roles || [];
}

// 用户私有角色 API
export async function listUserRoles() {
  const data = await jsonFetch(`${BASE}/user-roles`);
  return data.roles || [];
}

export async function createUserRole(payload) {
  return jsonFetch(`${BASE}/user-roles`, { method: "POST", body: JSON.stringify(payload) });
}

export async function updateUserRole(id, payload) {
  return jsonFetch(`${BASE}/user-roles/${id}`, { method: "PUT", body: JSON.stringify(payload) });
}

export async function deleteUserRole(id) {
  return jsonFetch(`${BASE}/user-roles/${id}`, { method: "DELETE" });
}
